export default __webpack_public_path__ + "static/media/5.b851cef8.jpg";